var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlanIconBlue = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_203_13289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.738784 8.4375H12.2615V9.79167H0.738784V8.4375ZM12.5873 2.02349C12.501 1.7492 12.3152 1.52242 12.0708 1.39303C11.8263 1.26364 11.5433 1.24224 11.284 1.33354L8.4206 2.34375L3.29939 0.3125L2.01909 0.989583L5.86 3.69792L3.29939 5.05208L0.738784 3.69792L0.0986328 4.375L2.65924 7.08333L11.9715 3.38984C12.2214 3.29063 12.4251 3.09284 12.54 2.83803C12.6548 2.58323 12.6718 2.29126 12.5873 2.02349Z",
    fill: "#00106E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_13289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 10,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlanIconBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/plan-icon-blue.8c8971bcd9852bd636c4b63d0cbaa63c.svg";